var state = {
    // importType: 'batch'
    isCreate: false,
    isDisabledAddBatch: false,
    isDisabledImport: true,
    isDefaultStatus: true,
    alreadyCreateNewPlanAmount: 0,
    isHasEdit: false,
    isOpenCreate: false,
    isOpensingleCreate: false,
    tabActiveName: 'batch',
    contractCode: '',
};
var mutations = {
    update: function (state, props) {
        for (var key in props) {
            if (state.hasOwnProperty(key)) {
                state[key] = props[key];
            }
        }
    },
};
var actions = {};
export default {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
};
